export default __webpack_public_path__ + "static/media/expense-tracker.25419f04.jpg";